export default "__VITE_ASSET__DNxpXwz6__"